import { render, staticRenderFns } from "./ConfiguracoesBancos.vue?vue&type=template&id=605527e5&"
import script from "./ConfiguracoesBancos.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesBancos.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesBancos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports